/**
 * Get the API base URL for fetch requests
 * In development, uses relative URLs to leverage the proxy in package.json
 * In production, uses REACT_APP_API_URL or window.location.origin
 */
export async function getApiUrl() {
  // In development, use relative URL to leverage proxy
  if (process.env.NODE_ENV === 'development' && !process.env.REACT_APP_API_URL) {
    return ''; // Relative URL will use proxy from package.json
  }
  
  // Otherwise, use the environment variable or fallback to window.location.origin
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/+$/, '');
  }
  
  return window.location.origin.replace(/\/+$/, '');
}

/**
 * Synchronous version that uses cached URL or falls back to origin
 * Use this when you can't use async (e.g., in useEffect dependencies)
 */
let cachedApiUrl = null;
export function getApiUrlSync() {
  if (cachedApiUrl) {
    return cachedApiUrl;
  }
  
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  if (isDevelopment && !process.env.REACT_APP_API_URL) {
    return '';
  }
  
  if (process.env.REACT_APP_API_URL) {
    cachedApiUrl = process.env.REACT_APP_API_URL.replace(/\/+$/, '');
    return cachedApiUrl;
  }
  
  // Fallback to origin
  cachedApiUrl = window.location.origin.replace(/\/+$/, '');
  return cachedApiUrl;
}

// Update cached URL when async version completes
getApiUrl().then(url => {
  cachedApiUrl = url;
}).catch(() => {
  // Ignore errors, use sync fallback
});
